import { AnalyticsEvent, AnalyticsParams } from 'models/Analytics';

const useGTM = () => {
    const sendEvent = ({ action, params = {} }: { action: AnalyticsEvent; params?: AnalyticsParams }) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: action, ...params });
    };

    return {
        sendEvent
    };
};

export default useGTM;
